module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "proto"
  }, [_c('h1', [_vm._v("Prototypes")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$route.fullPath))]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/prototypes/scene/ball"
    }
  }, [_vm._v("Ball")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/prototypes/scene/red"
    }
  }, [_vm._v("Red")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/prototypes/scene/fun"
    }
  }, [_vm._v("Fun")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/prototypes/scene/woody"
    }
  }, [_vm._v("Woody")])], 1), _vm._v(" "), _c('div', {
    staticClass: "fixed-box"
  }, [_c('div', {
    staticClass: "full"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db1679dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LayoutHTML/Prototype.vue
// module id = 614
// module chunks = 0